import { render, staticRenderFns } from "./AccessManagementPage.vue?vue&type=template&id=abe6b426&"
import script from "./AccessManagementPage.vue?vue&type=script&lang=ts&"
export * from "./AccessManagementPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports